import { Options } from '@angular-slider/ngx-slider';
import * as bootstrap from 'bootstrap';
import { Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, PLATFORM_ID, TemplateRef, ViewChild } from '@angular/core';
import { RegexService } from '../../shared/form-validation/regex.service';
import { ApiService } from '../../shared/services/apiService.service';
import { environment } from '../../../environments/environment';
import { debounce } from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { SkeletonService } from '../../shared/services/skeleton.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/internal/Subscription';
import { isPlatformBrowser } from '@angular/common';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { ToastrService } from 'ngx-toastr';
import { RootService } from 'src/app/shared/services/root.service';
import { ClevertapService } from 'src/app/shared/services/clevertap/clevertap.service';
import { FormErrorService } from 'src/app/shared/form-validation/form-error.service';
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import {  NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CanonicalService } from 'src/app/shared/seo/canonical.service';


@Component({
  selector: 'app-tataokhome',
  templateUrl: './tataokhome.component.html',
  styleUrls: ['./tataokhome.component.scss'],
})
export class TataokhomeComponent implements OnInit,OnDestroy {
  userData: any;
  @ViewChild('myCheckbox') myCheckbox!: ElementRef;
  @ViewChild('closeBtn') closeBtn!: ElementRef;
  
  isUserLoggedIn: boolean;
  pageURL: string;
  userLoginForm: FormGroup;
  isshowLogin: boolean = true;
  isshowOtp: boolean = false;
  isshowSignUp: boolean = false;
  isSentOTP: boolean = false;
  closeResult: string;

  constructor(private activatedRoute: ActivatedRoute,
    private apiservice: ApiService,
    private rootService: RootService,
    private cleverService: ClevertapService,
    private behaviourSub: BehaviourSubjectService,
    private regexService: RegexService,
    private spinner: NgxSpinnerService,
    public skeletonService: SkeletonService,
    private router:Router,
    private modalService: NgbModal,
    private fb: FormBuilder,
    @Inject(PLATFORM_ID) private platformId: Object,
    private toastrService: ToastrService,
    private localStorage: secureStorage,
    private formErrorService: FormErrorService,private canonicalservice: CanonicalService) {
    this.onScroll = debounce(this.onScroll, 300);
  }
  selectedButton: string = 'mostViewed';
  sub: Subscription = new Subscription();
  showLoader: any = false;

  mostViewData: boolean = false;
  RecentyViewData: boolean = false;
  productLoaded: boolean = false;
  model: boolean = false;
  budget: boolean = false;
  isCertified: boolean = false;
  models:any=[]
  minprice:any;
  maxprice:any;
  initialminprice:any;
  initialmaxprice:any;
  filterText: string = '';
  filterModel: string = '';
  filterBudget:string = '';
  states:any=[]
  distinctData:any
  checkBoxcheked:boolean=false;

  Selectedstates:any;
  isDropdownVisible = false;
  VehicleId:any;
  errorMessage:any;
  filteredstates: string[] ;
  filteredmodels: any[] ;
  selectedStae:boolean=false;
  flag='Certified'
  toggleCertification() {
    this.isCertified = !this.isCertified;
  }
  subMenu = [];
  isMobile = false;
  sortList = ["Select", "High To Low", "Low To High"];
    sortingType: string = 'Select'
    utm_source: any;
    utm_medium: any;
    utm_campaign: any;
    gclid: any;
    campaign_id:any
    dealercode: string;
     dealerLen: any = [];
  ngOnInit(): void {
          const url = this.router.url;
          const trimmedUrl = url.startsWith('/') ? url.substring(1) : url;
  
          this.canonicalservice.createCanonicalURL(trimmedUrl);
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('catIdid','false')
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
    this.sub.add(
      this.behaviourSub.isLoggedIn.subscribe(() => {
        this.isUserLoggedIn = this.rootService.isLoggedIn() ? true : false;
        this.userData = this.rootService.getUserData();
          if(this.isUserLoggedIn){
            this.closeModel()
          }
      })
    );
    this.sub.add(this.behaviourSub.isTataOkPLPPage.subscribe((ele)=>{
    // if(ele){
    //   if (isPlatformBrowser(this.platformId)) {
    //     let element = document.getElementById('otpVerification');
    //     element.click();
    //   }
    // }
    }));
    if (isPlatformBrowser(this.platformId)) {
    this.dealercode = localStorage.getItem('dealercd');
    }
    this.sub.add(this.behaviourSub.isTataOkLogin.subscribe((ele)=>{
      let data = {
        name:this.userData.first_name + ' ' + this.userData.last_name,
        contact:this.userData.mobile_number
      }
     if(ele && this.VehicleId){
      this.createLead(data);
     }
    }));
     if (isPlatformBrowser(this.platformId)) {
    this.pageURL = window.location.href;
    localStorage.removeItem('normalFilterValue');
    localStorage.removeItem('tataOkFilters');
    }
    this.userform();
this.onToggle(false);
    // this.getDistinctdata();
    this.getCategory();
    // this.getLOB(3);
    this.getUserdata();
    this.campaign();
    // this.getstate()
    this.setLoginHome();
  }
   this.sub.add(this.activatedRoute.queryParams.subscribe((params) => {
      if (params['dealer']) {
        if (isPlatformBrowser(this.platformId)) {

          localStorage.setItem("dealercd", params['dealer']);
          this.getDealer()
        }
      }
    }));
  }
  getDealer() {
    if (isPlatformBrowser(this.platformId)) {
    localStorage.removeItem("dealername")
    }
    let data ;
    {
          if (isPlatformBrowser(this.platformId)) {
       data = {
        "dealer_code": localStorage.getItem("dealercd"),
        "action_type": "dropdown"
    };
  }
      this.sub.add(this.apiservice.getDealerList(data).subscribe({
        next: (response: any) => {
          if (response["success"]) {
            this.dealerLen = response?.data;

    if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem("dealername", (this.dealerLen[0].division_name + '_' + this.dealerLen[0].dealer_code))
    }
            this.behaviourSub.dealerName.next(true)

          }
        },
        error: (error) => {
          this.toastrService.warning(error.data.msg);
        },
        complete: () => {
        }
      })
      );

    }
  
  }
  campaign() {
    this.activatedRoute.queryParams.subscribe(async (params: any) => {
      this.utm_source = await params['utm_source'];
      this.utm_medium = await params['utm_medium'];
      this.utm_campaign = await params['utm_campaign'] || await params['utm_campaignname'];
      this.gclid = await params['gclid'];
      this.campaign_id = await params['campaign_id'];
    })
  }
  environment1 = environment.s3bucket.url;
  Certified = [1, 2, 3, 4, 56, 7, 8, 9, 0, 0, 12, 18, 0];
  ListingData:any = [];
  ParknSell:any = [];
  value: number = 0;
  highValue: number = 0;
  subMenuType: any;
  value1: number = 0;
  highValue1: number = 0;
  options: Options = {
    floor: 0,
    ceil: 100,
  };
  options1: Options = {
    floor: 0,
    ceil: 100,
  };
  startValue: number = 0;
  endValue: number = 9;
TotalCount:any;
TotalCountRecent:any;
offset: number = 0;
offsetrecent:number=0;
pageSize: number = 1;
disableForm:boolean=false;
userForm: FormGroup;
isFilter:boolean=false
order_by:string=''
checkBoxControl = new FormControl(false);
  @HostListener('window:scroll', ['$event'])
  onScroll() {
    if (isPlatformBrowser(this.platformId)) {
    if (this.mostViewData) {
      if ((window.innerHeight + window.scrollY+500) >= document.body.offsetHeight) {
        if (this.TotalCount != null && this.TotalCount != '' && this.TotalCount != undefined) {
          if (this.TotalCount>0 && this.ParknSell.length>0) {
            if (this.ParknSell.length<this.TotalCount) {
              this.offset += 10;
                this.getmostviewdata(this.offset);
            }
          }
       }
      }
    }
    else{
    if ((window.innerHeight + window.scrollY+1000) >= document.body.offsetHeight) {
      if (this.TotalCountRecent != null && this.TotalCountRecent != '' && this.TotalCountRecent != undefined) {
        if (this.TotalCountRecent>0 && this.ListingData.length>0) {
          if (this.ListingData.length<this.TotalCountRecent) {
            this.offsetrecent += 10;
              this.getRecentlyadded(this.offsetrecent);
          }
        }
     }
    }
  }
}

  }
  showmodel() {
    this.model = true;
    this.budget = false;
  }
  showbudget() {
    this.model = false;
    this.budget = true;
  }
  mostViewcontent(button:string) {
    this.spinner.show()
    this.selectedButton = button;
    this.mostViewData = true;
    this.RecentyViewData = false;
    this.ParknSell=[]
    this.offset=0
    this.getmostviewdata(0);
    // this.spinner.hide();
  }
  recentaddedContent(button:string) {
    this.spinner.show()
    this.selectedButton = button;
    this.mostViewData = false;
    this.RecentyViewData = true;
    this.ListingData=[]
    this.offsetrecent=0
    this.getRecentlyadded(0)
    // this.spinner.hide();
  }
  stopPropagation(event: Event): void {
    event.stopPropagation();
  }
  onToggle(isCertified: boolean) {
    this.ParknSell=[]
    this.ListingData=[]
    this.sortingType='Select'
    this.order_by=''
    this.spinner.show()
    if (isCertified) {
      this.flag='Certified'
      this.getDistinctdata();
      this.getLOB(2);
      if (this.selectedButton === 'mostViewed') {
        this.mostViewcontent('mostViewed');
      }
      else
      {
      this.recentaddedContent('recentlyAdded')
      }
    } else {
      this.flag='Non-Certified';
      this.getDistinctdata();
      this.getLOB(3);
      if (this.selectedButton === 'mostViewed') {
        this.mostViewcontent('mostViewed');
      }
      else
      {
      this.recentaddedContent('recentlyAdded')
      }
    }
    // this.spinner.hide()
  }
  getmostviewdata(val:any){
    if (val == 0) {
      this.ParknSell = [];
    }
    this.showLoader = true;
    let data = {
      offset: val,
    city:"",
    minimum_msrp:"",
    maximum_msrp:"",
    model:"",
    vehicle_type:"",
    order_by:this.order_by == ''? '-view_count': this.order_by,
    params_approval_status:'APPROVED',
    cat_id:this.flag === 'Certified' ? 2 : 3,
    distributor_code:this.dealercode ? this.dealercode : ''

    };
    this.spinner.show()
    try {
      this.sub.add(   this.apiservice.getTataokhomedata(data).subscribe({
        next: (response) => {
          this.productLoaded=true;
          if (response.success) {
            if (this.ParknSell.length<10) {
              this.ParknSell=[...response.data]
            }
            else{
              this.ParknSell = [...this.ParknSell, ...response.data];
            }
            this.TotalCount=response.total_count ?response.total_count :0;
            this.showLoader = false;
          }
          else
          {
            this.ParknSell=[];
            this.showLoader = false;
          }
          this.spinner.hide();
        },
        error: (error) => {
          this.spinner.hide();
          this.showLoader = false;

        },
      })
      )
    } catch (error) {
    }
  }
  getRecentlyadded(val:any) {
    if (val == 0) {
      this.ListingData = [];
    }
    this.isFilter=false
    this.showLoader = true;
    let data = {
      offset: val,
    city:"",
    minimum_msrp:"",
    maximum_msrp:"",
    model:"",
    vehicle_type:"",
    order_by:this.order_by == ''? '': this.order_by,
    params_approval_status:'APPROVED',
    cat_id:this.flag === 'Certified' ? 2 : 3,
    distributor_code:this.dealercode ? this.dealercode : ''
    };
    this.spinner.show()
    try {
      this.sub.add(   this.apiservice.getTataokhomedata(data).subscribe({
        next: (response) => {
          this.productLoaded=true;
          if (response.success) {
          if (this.ListingData?.length<10) {
            this.ListingData=[...response.data]
          }
          else{
            this.ListingData = [...this.ListingData, ...response.data];
          }
          this.TotalCountRecent=response.total_count ?response.total_count :0;
          this.showLoader = false;
        }
        else{
          this.ListingData=[];
          this.showLoader = false;
        }
        this.spinner.hide();
        },
        error: (error) => {
          this.spinner.hide();
          this.showLoader = false;

        },
      })
      )
    } catch (error) {
    }

  }
  getDistinctdata() {
    let Payload = {
      cat_id : this.flag =='Certified' ? 2 : 3
    }
    try {
      // this.sub.add(this.apiservice.getTataokhomedatadistinct(Payload).subscribe((res: any) => {
      //   if (res.success) {
      //     this.distinctData=res.data
      //     this.states=res.data.state_list;
      //     this.filteredstates=this.states;
      //   }
      //   else
      //   {
      //     this.distinctData=[]
      //     this.states=[]
      //     this.filteredstates=[]
      //     this.filterText=''
      //   }

      // })
      // )
      this.sub.add(this.apiservice.getTataokhomedatadistinct(Payload)
      .subscribe({
        next: (res: any) => {
          if (res.success) {
            this.distinctData=res.data
            this.states=res.data.state_list;
            this.filteredstates=this.states;
            if (this.states?.length == 0) {
               this.filterText=''
            }


          } else {
            this.distinctData=[]
          this.states=[]
          this.filteredstates=[]
          this.filterText=''

          }
        },
        error: () => {
          this.distinctData=[]
          this.states=[]
          this.filteredstates=[]
          this.filterText=''

        },
        complete: () => { }

      })
    )
    } catch (error) {
    }
  }
  onMinPriceChange(data:any) {
    if (isPlatformBrowser(this.platformId)) {
    setTimeout(() => {
    this.value=data.target.value
    if (this.value > this.highValue) {
      this.value = this.highValue;
    }
    this.onSliderChange('')
  }, 500);
}
  }

  onMaxPriceChange(data:any) {
    if (isPlatformBrowser(this.platformId)) {
    setTimeout(() => {
    this.highValue=data.target.value
    if (data.target.value == '') {
      this.highValue = this.distinctData?.msrp_min_max?.max_msrp
    }
    if (this.highValue < this.value) {
      this.highValue = this.value;
    }
    this.onSliderChange('')
  }, 500);
}
}
onMinPriceChange1(data:any) {
  if (isPlatformBrowser(this.platformId)) {
  setTimeout(() => {
  this.value1=data.target.value
  if (this.value1 > this.highValue1) {
    this.value1 = this.highValue1;
  }
  this.onSliderChange('')
}, 500);
  }
}

onMaxPriceChange1(data:any) {
  if (isPlatformBrowser(this.platformId)) {
  setTimeout(() => {
  this.highValue1=data.target.value
  if (data.target.value == '') {
    this.highValue1 = this.distinctData?.msrp_min_max?.max_msrp
  }
  if (this.highValue1 < this.value1) {
    this.highValue1 = this.value1;
  }
  this.onSliderChange('')
}, 500);
  }
}
onSubMenuClick(value: any, value2: any, flag) {
  if (isPlatformBrowser(this.platformId)) {
  this.subMenuType = value2;
  if (value2) {
    this.getPPL(value2);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.dropdown-menu .dropdown-item').forEach(function (element) {
      element.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    });
  });
}
}

onImageClick(value:any){
  if (isPlatformBrowser(this.platformId)) {
  const dropdownElement = document.querySelector('.dropdown-menu.show');
  if (dropdownElement) {
    dropdownElement.classList.remove('show');
  }
}
}

getTotalMenu(val: any, val2: any) {
  this.onSubMenuClick(val, this.models[0].sub_cat_id, '')
}
onlyNumberKey(event: any) {
  return this.regexService.NumberKeyEvent(event);
}
filterstates() {
  if (this.filterText.trim() === '') {
    this.filteredstates = [...this.states];
  } else {
    this.filteredstates = this.states.filter(states =>
      states?.toLowerCase().includes(this.filterText?.toLowerCase())
    );
  }
}
filtermodel() {
  if (this.filterModel.trim() === '') {
    this.filteredmodels = [...this.models];
    this.getPPL(this.filteredmodels[0].sub_cat_id);
    this.subMenuType=this.filteredmodels[0].sub_cat_id
  } else {
    this.filteredmodels = this.models.filter(model =>
      model?.sub_cat_name?.toLowerCase().includes(this.filterModel?.toLowerCase())
    );
    if (this.filteredmodels?.length>0) {
      this.getPPL(this.filteredmodels[0].sub_cat_id)
      this.subMenuType=this.filteredmodels[0].sub_cat_id
    }
    else{
      this.filteredmodels=[]
      this.subMenu=[]
    }

  }
}
getblurmodels(){
  const modelValue = this.filterModel;
  if (this.filteredmodels?.length > 0 && this.subMenu?.length > 0) {
    const isModelValueInFilteredModels = this.filteredmodels.some((model: any) => model.sub_cat_name === modelValue);
    const isModelValueInSubMenu = this.subMenu.some((menu: any) => menu.name === modelValue);
    if (!isModelValueInSubMenu) {
      this.filterModel = '';
      this.filteredmodels = this.models;
    }
  }
  else{
    this.filterModel = '';
    this.filteredmodels = this.models;
  }

}
getblurstate(){
  if (isPlatformBrowser(this.platformId)) {
  setTimeout(() => {
  const modelValue = this.filterText;
  if (this.filteredstates?.length > 0) {
    const isModelValueInFilteredstate = this.filteredstates.some((state: any) => state === modelValue);
    if (!isModelValueInFilteredstate) {
      this.filterText = '';
      this.filteredstates = this.states;
    }
  }
  else{
    this.filterText = '';
    this.filteredstates = this.states;
  }
}, 300);
  }
}
redirect(id:number){
  this.router.navigate([`/buy-used-vehicles-productdetail/${id}`])
}
    contactDealer(id:any){
      this.VehicleId=id;
      this.disableForm=false;
      this.checkBoxcheked=false
      this.checkBoxControl.setValue(false);
      this.setFormHome()
    }
    userform(){
      this.userForm = this.fb.group({
        name: ['', [Validators.required]],
        contact: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
        consent: ['', Validators.required]
      });
    }
    onSubmit() {
      if (this.userForm.valid) {
        this.spinner.show()
        this.showLoader = true;
          this.createLead(this.userForm.value)
      } else {
        this.disableForm=false;
      }
    }
    onCheckboxChange(checked: boolean) {
      if (checked) {
        this.checkBoxcheked=true
      } else {
        this.checkBoxcheked=false
      }
    }
    notAllowSpace(event: any) {
      if (event.target.selectionStart === 0 && event.which === 32) {
        event.preventDefault();
      }
    }
    getFilterdata(val:any){
      this.showLoader = true;

    this.spinner.show()

          this.spinner.hide();
          this.productLoaded=true;
          const route = ['/buy-used-vehicles-productlist'];
          const queryParams: any = {};
     if (this.filterModel) {
       queryParams.model = this.filterModel;
     }
     if (this.isMobile) {
      if (this.value1) {
        queryParams.minprice = this.value1.toString();
      }
      if (this.highValue1) {
        queryParams.maxprice = this.highValue1.toString();
      }
     }
     if (!this.isMobile) {
     if (this.value) {
       queryParams.minprice = this.value.toString();
     }
     if (this.highValue) {
       queryParams.maxprice = this.highValue.toString();
     }
    }
    //  if (this.filterText) {
    //    queryParams.states = this.filterText;
    //  }
    const modelValue = this.filterText;
    if (this.filteredstates?.length > 0) {
      const isModelValueInFilteredstate = this.filteredstates.some((state: any) => state === modelValue);

      if (!isModelValueInFilteredstate) {
      }
      else{
        queryParams.states = this.filterText;
      }
    }
    if (isPlatformBrowser(this.platformId)) {
     localStorage.setItem('max_price', this.distinctData?.msrp_min_max?.max_msrp)
     localStorage.setItem('tataOkFilters', JSON.stringify(queryParams));
    }
          // this.router.navigate(route, { queryParams });
          let catId = this.flag =='Certified' ? 2 : 3
          this.router.navigate([route + '/'+ catId]);
          this.behaviourSub.filterValue.next(false)
    }
    changestates(data:any){

      this.Selectedstates=data;
      this.filterText=data
    }
    createLead(data:any){
      this.errorMessage = ''
      const nameParts = data.name.split(' ');
      const firstName = nameParts[0];
      const lastName = nameParts[1];
     let Payload={
      "first_name":firstName?firstName:'',
      "last_name": lastName?lastName:'',
      "mobile_no":data.contact,
      "vehicle_id":this.VehicleId,
      "lead_source":"osp",
      "financing":data.consent == 'yes' ? true : false,
      "address_one":this.userData.address_one,
          "address_two":this.userData.address_two,
          "city":this.userData.city,
          "district":this.userData.district,
          "pincode":this.userData.pincode,
          "state":this.userData.state,
          "taluka":this.userData.taluka,
          "utm_source":this.utm_source ? this.utm_source : '',
         "utm_medium":this.utm_medium  ? this.utm_medium : '',
        "utm_campaign":this.utm_campaign ? this.utm_campaign : '',
        "campaign_id":this.campaign_id ? this.campaign_id : '',
        "device_source":"Fleet Verse Web"
     };
     this.spinner.show()
     this.showLoader = true;
     try {
      this.sub.add( this.apiservice.getCreateLead(Payload).subscribe({
        next: (response) => {

          if (response.success) {
            this.toastrService.success(response?.data?.msg);
            this.disableForm=true;
            this.productLoaded=true
            this.errorMessage=response;
            this.spinner.hide();
            this.showLoader = false;
          }

          else{
            this.showLoader = false;
          this.spinner.hide();
            this.toastrService.warning(response?.data?.msg || response.msg);
            if (isPlatformBrowser(this.platformId)) {
              let element =document.getElementById('closeBtn');
              element.click();
            }
          }

        },
        error: (error) => {
          this.showLoader = false;
          this.spinner.hide();
          if (isPlatformBrowser(this.platformId)) {
            let element =document.getElementById('closeBtn');
            element.click();
          }
        },
       })
      )
    } catch (error) {
    }

    }
    getLead(data:any){

     let Payload={
    "offset":data
     };
     this.spinner.show()
     try {
      this.sub.add(this.apiservice.getTataokLead(Payload).subscribe({
        next: (response) => {
          this.spinner.hide();
          this.productLoaded=true
        },
        error: (error) => {
        },
       })
      )
    } catch (error) {
    }
    }
    onMenuclick(data:any){
    this.filterModel=data.name
    }
    getCategory(){
      try {
        this.sub.add(this.apiservice.getTataokCategory('')
          .subscribe({
            next: (res: any) => {
            },
            error: () => {
            },
            complete: () => { }

          })
        )
      } catch (error) {
      }
    }
    getLOB(data:any){
      this.filterText=''
      this.filterModel=''
      this.filterBudget=''
      this.value=0
      this.highValue=0
      this.value1=0
      this.highValue1=0
      // localStorage.removeItem('tataOkFilters')
      let payload={
        "cat_id":data
    }
      try {
        this.sub.add(this.apiservice.getTataokLOB(payload)
          .subscribe({
            next: (res: any) => {
              if (res.success && res?.data && res.data?.length > 0) {
                // this.models=res.data;
                // this.models = [];
                // res.data.filter((element)=>{
                //   if (element.sub_cat_name !=='CV NTML' && element.sub_cat_name !=='ISUZU DMAX'&& element.sub_cat_name !=='M&HCV CONST'&& element.sub_cat_name !=='MAGIC IRIS'&& element.sub_cat_name !=='MCV CARGO'&& element.sub_cat_name !=='NTML'&& element.sub_cat_name !=='PCV - VENTURE'&& element.sub_cat_name !=='SMALL CARS'&& element.sub_cat_name !=='TASL'&& element.sub_cat_name !=='HCL CONST' ) {
                //     this.models.push(element)
                //   }
                // })
                const excludedNames = [
                  'CV NTML',
                  'ISUZU DMAX',
                  'M&HCV Const',
                  'Magic IRIS',
                  'MCV Cargo',
                  'NTML',
                  'PCV - Venture',
                  'Small Cars',
                  'TASL',
                ];
                const includedNames = [
                  'ScPass',
                  'ICV Trucks',
                  'Pickups',
                  'HCV Const',
                  'HCV Cargo',
                  'Buses',
                  'MCV Trucks',
                  'LCV',
                  'CV NTML',
                  'SCVPass',
                  'SCV Cargo',
                ];

                this.models = [];

                this.models = res.data.filter((element) => includedNames.includes(element.sub_cat_name));

                this.filteredmodels=this.models
                this.onSubMenuClick('','',this.models[0].sub_cat_id)
              } else {
                this.models = [];
                this.subMenu=[];
                this.filteredmodels=[]
                this.filterModel=''
              }
            },
            error: () => {
              this.models = [];
              this.subMenu=[];
              this.filteredmodels=[]
              this.filterModel=''

            },
            complete: () => { }

          })
        )
      } catch (error) {
      }
    }
    getPPL(data:any){
      let payload={
        "subcat_id":data
    }
      try {
        this.sub.add(this.apiservice.getTataokPPL(payload)
          .subscribe({
            next: (res: any) => {
              if (res?.success) {
                this.subMenu=res?.data
              }
              else
              {
                this.subMenu=[]
              }
            },
            error: () => {
            },
            complete: () => { }

          })
        )
      } catch (error) {
      }
    }
    getUserdata(){
      this.sub.add(this.apiservice.getUserData().subscribe({
        next: (response: any) => {
        this.userData=response?.data;
        }
      }));
    }
    setFormHome(){
      if (isPlatformBrowser(this.platformId)) {
      const fullName = this.userData?.first_name + ' ' + this.userData?.last_name;
      this.userForm = this.fb.group({
        name: [fullName ? fullName :'', [Validators.required]],
        contact: [this.userData?.mobile_number ? this.userData?.mobile_number : '', [Validators.required, Validators.pattern(/^\d{10}$/)]],
        consent: ['yes', Validators.required]
      });
      this.myCheckbox.nativeElement.checked = false;
      if (this.userForm.controls['contact'].invalid) {
        this.userForm.controls['contact'].markAsTouched();
      }
      if (this.isUserLoggedIn) {
        // this.router.navigate(['/buy-used-vehicles']);
      } else {

       let url = '/buy-used-vehicles'
       if (isPlatformBrowser(this.platformId)) {
        localStorage.setItem('previousUrl', url); // Optional: Move to a service
       }
        // this.router.navigate(['/login/']);
        this.setLoginHome()
      }
    }
    }

    getdefault(data:any){

      if (data) {
        const formattedData = data.replace(/\s+/g, '_').replace(/\./g, '_');

        return `https://d26uj34udz53va.cloudfront.net/tataok_auction/Vehicle_Category/${formattedData}.webp`
      }
      else
      {
        return 'https://ibpodev.home.tatamotors/catalog/assets/images/default_image.jpg'
      }

    }
    getBudget(){
      // this.value=this.distinctData.msrp_min_max.min_msrp ? this.distinctData.msrp_min_max.min_msrp : 0 ;
      // this.value=0
        this.highValue=this.distinctData.msrp_min_max.max_msrp ? this.distinctData.msrp_min_max.max_msrp : 0;
        // this.value1=0
        // this.value1=this.distinctData.msrp_min_max.min_msrp ? this.distinctData.msrp_min_max.min_msrp : 0;
        this.highValue1=this.distinctData.msrp_min_max.max_msrp ? this.distinctData.msrp_min_max.max_msrp : 0;
        if (this.value === 0 && this.highValue === 0) {
          this.value = 0;
          this.highValue = 0;
        }
        if (this.value1 === 0 && this.highValue1 === 0) {
          this.value1 = 0;
          this.highValue1 = 0;
        }
        this.options1 = {
          floor: 0,
          ceil: this.highValue1 ? this.highValue1 : 100
        }
        this.options = {
          floor: 0,
         ceil: this.highValue ? this.highValue : 100,
        }
        if (this.isMobile) {
        this.filterBudget=`₹${this.value1} to ₹${this.highValue1}`
        }
        else
        {
           this.filterBudget=`₹${this.value} to ₹${this.highValue}`
        }
    }
    getBudgetMobile(){
      this.isDropdownVisible = !this.isDropdownVisible;
      if (this.isDropdownVisible) {
        // this.value=this.distinctData.msrp_min_max.min_msrp ? this.distinctData.msrp_min_max.min_msrp : 0 ;
        this.value=0
        this.highValue=this.distinctData.msrp_min_max.max_msrp ? this.distinctData.msrp_min_max.max_msrp : 0;
        this.value1=0
        // this.value1=this.distinctData.msrp_min_max.min_msrp ? this.distinctData.msrp_min_max.min_msrp : 0;
        this.highValue1=this.distinctData.msrp_min_max.max_msrp ? this.distinctData.msrp_min_max.max_msrp : 0;
        if (this.value === 0 && this.highValue === 0) {
          this.value = 0;
          this.highValue = 0;
        }
        if (this.value1 === 0 && this.highValue1 === 0) {
          this.value1 = 0;
          this.highValue1 = 0;
        }
        this.options1 = {
          floor: 0,
          ceil: this.highValue1 ? this.highValue1 : 100
        }
        this.options = {
          floor: 0,
         ceil: this.highValue ? this.highValue : 100,
        }
        if (this.isMobile) {
        this.filterBudget=`₹${this.value1} to ₹${this.highValue1}`
        }
        else
        {
           this.filterBudget=`₹${this.value} to ₹${this.highValue}`
        }
      }


    }
    onSliderChange(data:any){
if (this.isMobile) {
  this.filterBudget=`₹${this.value1}   to   ₹${this.highValue1}`
  }
  else
  {
     this.filterBudget=`₹${this.value}   to   ₹${this.highValue}`
  }

    }
    getFirstPartOfOwners(owners: string | undefined): string {
      if (!owners) {
        return '';
      }
      return owners.split(/[-\s]/)[0]; // Split by space or dash
    }
    exploreProduct(){
      if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('tataOkFilters')
      localStorage.removeItem('normalFilterValue')
      }
      this.router.navigate(['/buy-used-vehicles-productlist']);
    }
    onFilterChange(event: any, source: any){
      var type
      if (source == '') {
        type = event?.target?.value ? event?.target?.value : event
      }
      else {
        type = event
      }
      if (this.selectedButton === 'mostViewed') {
        this.spinner.show()
        if (type == 'High To Low') {
          this.order_by='-dealer_suggestive_price';
          this.getmostviewdata(0);
          // this.ParknSell = this.ParknSell.sort((a: any, b: any) => {
          //   return Number(b.dealer_suggestive_price) - Number(a.dealer_suggestive_price);
          // });
        } else if (type == 'Low To High') {
          this.order_by='dealer_suggestive_price'
          this.getmostviewdata(0);
          // this.ParknSell = this.ParknSell.sort((a: any, b: any) => {
          //   return Number(a.dealer_suggestive_price) - Number(b.dealer_suggestive_price);
          // });
        }
        else{
             this.order_by=''
             this.getmostviewdata(0);
        }
        this.spinner.hide()
      }
      else
      {
        this.spinner.show()
        if (type == 'High To Low') {
          this.order_by='-dealer_suggestive_price';
          this.getRecentlyadded(0)
          // this.ListingData = this.ListingData.sort((a: any, b: any) => {
          //   return Number(b.dealer_suggestive_price) - Number(a.dealer_suggestive_price);
          // });
        } else if (type == 'Low To High') {
           this.order_by='dealer_suggestive_price'
           this.getRecentlyadded(0)
          // this.ListingData = this.ListingData.sort((a: any, b: any) => {
          //   return Number(a.dealer_suggestive_price) - Number(b.dealer_suggestive_price);
          // });
        }
        else{
           this.order_by=''
           this.getRecentlyadded(0)
        }
        this.spinner.hide()
      }

    }
    getstate(){
      this.sub.add(this.apiservice.getLocationsstate().subscribe(
        res => {
          this.states=res
        this.filteredstates=this.states
        }, (err) => {
          // Swal.fire('Oops...', err.error.data.msg, 'error')
        }))

    }
    getiscover(data:any){
      if (data.length > 0) {
        const original_data = data
        const images = [...data];
        const filteredImages = images.filter(item => item.is_cover === true);
        if (filteredImages.length > 0) {
            return filteredImages[0].path
        } else {
            return original_data[0].path
        }
      }
      else{
        return '../../../assets/images/default_image.jpg'
      }

    }

    closeModel() {
      if (isPlatformBrowser(this.platformId)) {
        let element = document.getElementById('closeBtn1');
       
        if(element && this.isshowLogin){
          element.click();
        }
        let element1 = document.getElementById('closeBtn2');
        if(element1){
          element1.click();
        }
      }
    }

    setLoginHome(){
      if (isPlatformBrowser(this.platformId)) {
      this.userLoginForm = this.fb.group({
        mobile_number: [this.userData?.mobile_number ? this.userData?.mobile_number : '', [Validators.required, Validators.pattern(this.regexService.Phone)]],
      });
      }
    }

    

    showLogin() {
      this.isshowLogin = true;
      this.isshowOtp = false;
      this.isshowSignUp = false;
      if(window.location.href.includes('buy-used-vehicles')){
        let ele = document.getElementById('otpVerification')
        ele.click(); 
      }
    }
  
    showOtp() {
      this.isshowLogin = false;
      this.isshowOtp = true;
      this.isshowSignUp = false;
    }
  
    showSignup(){
      this.isshowLogin = false
      this.isshowOtp = false;
      this.isshowSignUp = true;
    }

    sentOtp() {
      if (isPlatformBrowser(this.platformId)) {
        if (this.isSentOTP) {
          return;
        }
        this.isSentOTP = true;
        if (this.userLoginForm.status === 'INVALID') {
          this.formErrorService.displayFormErrors(this.userLoginForm);
          return;
        }
        this.spinner.show();
        let data = {
          mobile_number: this.userLoginForm.controls['mobile_number'].value,
          action_type: 'login',
          user_source: "Tataok"
        };
        this.sub.add(
          this.apiservice.sentOtp1(data).subscribe({
            next: (response: any) => {
              this.isSentOTP = false;
              if (response.success) {
                this.toastrService.success(response.data.msg);
                if(this.checkBoxcheked && this.userLoginForm.controls['mobile_number']?.value){
                  this.getConsentData(this.userLoginForm.controls['mobile_number']?.value)
                }
                this.spinner.hide();
                if (isPlatformBrowser(this.platformId)) {
                this.localStorage.setItem("loginNumber", JSON.stringify(this.userLoginForm.controls['mobile_number'].value))
                localStorage.removeItem("signup")
                }
                this.isshowLogin = false
                this.isshowOtp = true;
                this.isshowSignUp = false;
  
                // this.router.navigate(['/otp/']);
                if (isPlatformBrowser(this.platformId)) {
                  window.scroll(0, 0);
                }
              }
              else {
                    this.toastrService.warning('Something went wrong!');
                    this.spinner.hide();
                    this.closeModel()
                  }
            },
            error: () => {
              this.toastrService.warning('Something went wrong!');
              this.spinner.hide();
              this.closeModel()
            },
            complete: () => { },
          })
        );
      }
    }

    getConsentData(value) {
      if (isPlatformBrowser(this.platformId)) {
      const signup = JSON.parse(this.localStorage.getItem("signup")) ? true : false;
      let data = {
        "mobile_number": value,
        'source': signup ? 'Web Registration' : 'Web Login'
      }
      this.apiservice.get_amc_consent_view(data).subscribe((res) => {
      })
    }
    }
    

    ngOnDestroy(): void {
      if (isPlatformBrowser(this.platformId)) {
        this.sub.unsubscribe()
      }
    }
}
